import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import renderTooltip from '../../components/siteadmin/SiteSettingsForm/toolTipHelper.js';
import CurrencyConverter from '../CurrencyConverter';
import messages from '../../locale/messages';
import { getBillingDetails } from '../../helpers/Pricing/getBillingDetails.js';
import s from './Payment.css';
class PaymentDetails extends Component {
	static propTypes = {
		checkIn: PropTypes.string.isRequired,
		checkOut: PropTypes.string.isRequired,
		total: PropTypes.number.isRequired,
		basePrice: PropTypes.number.isRequired,
		cleaningPrice: PropTypes.number.isRequired,
		discount: PropTypes.number,
		discountType: PropTypes.string,
		serviceFee: PropTypes.number.isRequired,
		currency: PropTypes.string.isRequired,
		formatMessage: PropTypes.any,
		taxPrice: PropTypes.number
	};

	render() {
		const { formatMessage } = this.props.intl;
		const { checkIn, checkOut, basePrice, cleaningPrice, taxPrice, total, taxValue, bookingSpecialPricing } = this.props;
		const { discount, discountType, serviceFee, currency, petFee } = this.props;
		const { dayDifference, dayPrice, isAverage, guestTotal, isSpecialPricingAssigned } = getBillingDetails({ checkIn, checkOut, bookingSpecialPricing, basePrice, total, guestServiceFee: serviceFee, petFee });

		return (
			<div>
				<div>
					<h3 className={cx(s.pricingTitle, 'rtlBookText')}><FormattedMessage {...messages.priceDetails} /></h3>
					<div className={cx(s.grid)}>
						<div className='tooltipFlex paymentDetailsFlexLeft'>
							<>{isSpecialPricingAssigned && renderTooltip(formatMessage(messages.averagePricePerNight), 'commonTooltipIcon')}</>
							<div className={cx(s.specialPriceText, 'directionLtrTextRight')}>
								<CurrencyConverter
									amount={isAverage}
									from={currency}
								/>
								{' x'} {dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
							</div>
						</div>
						<div className='paymentDetailsFlexRight'>
							<CurrencyConverter
								amount={dayPrice}
								from={currency}
							/>
						</div>

					</div>
					{
						cleaningPrice > 0 && <div className={cx(s.grid)}>
							<div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.cleaningFee} /></div>
							<div className='paymentDetailsFlexRight'>
								<CurrencyConverter
									amount={cleaningPrice}
									from={currency}
								/>
							</div>
						</div>
					}
					<div className={cx(s.grid)}>
						<div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.serviceFee} /></div>
						<div className='paymentDetailsFlexRight'>
							<CurrencyConverter
								amount={serviceFee}
								from={currency}
							/>
						</div>
					</div>
					{
						taxPrice > 0 && <div className={cx(s.grid)}>
							<div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.tax} /> {taxValue > 0 && `(${taxValue.toFixed(2)}%)`}</div>
							<div className='paymentDetailsFlexRight'>
								<CurrencyConverter
									amount={taxPrice}
									from={currency}
								/>
							</div>
						</div>
					}
					{
						petFee > 0 && <div className={cx(s.grid)}>
							<div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.petFee} /></div>
							<div className='paymentDetailsFlexRight'>
								<CurrencyConverter
									amount={petFee}
									from={currency}
								/>
							</div>
						</div>
					}
					{
						discount > 0 && <div className={cx(s.grid)}>
							<div className='paymentDetailsFlexLeft'>{discountType}</div>
							<div className='paymentDetailsFlexRight'>
								- <CurrencyConverter
									amount={discount}
									from={currency}
								/>

							</div>
						</div>
					}
					<div className={cx(s.grid, s.totalValue)}>
						<div className='paymentDetailsFlexLeft'><FormattedMessage {...messages.total} /></div>
						<div className='paymentDetailsFlexRight'> <CurrencyConverter
							amount={guestTotal}
							from={currency}
						/></div>
					</div>

				</div>
			</div>
		);
	}
}

export default injectIntl(withStyles(s)(PaymentDetails));
